/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */

 import React, { useState, useEffect } from "react"
 import { useSelector } from "react-redux"
 import { useToken, DownloadMoment, Step, StepController } from "trux"
 import { AutoAddMomentToTraceiDDialog } from "../AutoAddMomentToTraceiDDialog"
 
 const DownloadMomentWrapper = ({
     onClose,
     history,
     expirationDays,
     onSetStep,
 }) => {
     const [step, setStep] = useState("download")
     const token = useToken("DownloadMomentWrapper")
     const moment = useSelector((state) => {
         return state.video.value.source
     })
     const team = useSelector((state) => {
         return state.team.value
     })
 
     const handleOnClick = (downloadStatus) => {
         setStep("auto-add")
     }
 
     useEffect(() => {
         if (typeof onSetStep === "function") {
             onSetStep(step)
         }
     }, [step])
 
     return (
         <StepController step={step}>
             <Step name="download">
                 <DownloadMoment
                     item={moment}
                     onClose={onClose}
                     history={history}
                     showChildren={false}
                     expirationDays={expirationDays}
                     handleOnClickDownloadNow={handleOnClick}
                 />
             </Step>
             <Step name="auto-add">
                 <AutoAddMomentToTraceiDDialog
                     open={true}
                     team={team}
                     token={token}
                     moment={moment}
                     onClose={onClose}
                     title={"Downloaded"}
                     disableAutoAdd={moment?.type === "FullGameVideo"}
                 />
             </Step>
         </StepController>
     )
 }
 
 export default DownloadMomentWrapper
 